export default __webpack_public_path__ + "static/media/cdiscount-logo.0f4cf544.png";